<button
  (click)="isOpen = !isOpen; checkDarkMode()"
  type="button"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  mat-icon-button
  matTooltip="More actions"
  i18n-matTooltip
>
  <mat-icon>more_vert</mat-icon>
  @if (isAnyExecuting()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="[
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
    { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom' }
  ]"
  (backdropClick)="isOpen = false"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="backdrop"
  (detach)="isOpen = false"
>
  <div class="action-dropdown-overlay" [class.dark-mode]="darkMode()">
    <div class="flex flex-col gap-1">
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
